"use client";

import { RotateCcw } from 'lucide-react';
import { TextScramble } from '@/components/ui/effects/text-scramble';

interface FilterCategoryHeaderProps {
  title: string;
  categoryKey: string;
  onReset: (category: string) => void;
  selectionCount?: number;
}

export function FilterCategoryHeader({ 
  title, 
  categoryKey, 
  onReset,
  selectionCount = 0
}: FilterCategoryHeaderProps) {
  const handleReset = () => {
    onReset(categoryKey);
  };

  return (
    <div className="animate-fade-in" style={{ animationDuration: '400ms', animationFillMode: 'forwards' }}>
      <div className="flex items-center justify-between mb-2 transform transition-all duration-300 ease-in-out">
        <span className="text-[12px] uppercase font-mono text-black font-semibold hover:text-black/70">
          [ <TextScramble text={title} className="inline-block hover:cursor-pointer" /> ]
        </span>
        <button 
          onClick={handleReset} 
          className={`p-1 flex items-center justify-center rounded-full transition-all duration-300 ease-in-out ${selectionCount > 0 ? 'text-black bg-zinc-200 hover:bg-zinc-300' : 'text-zinc-400 hover:bg-zinc-200'}`}
          aria-label={`Reset ${title} filter`}
          disabled={selectionCount === 0}
        >
          <RotateCcw 
            size={14} 
            className={`transition-all duration-300 ease-in-out hover:rotate-180 ${selectionCount > 0 ? 'text-black' : 'text-gray-400'}`} 
          />
        </button>
      </div>
      <div className="border-t border-dashed border-gray-300 pt-2 mb-2 animate-fade-in" style={{ animationDelay: '100ms', animationFillMode: 'forwards' }}></div>
    </div>
  );
}
